import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AmdocsEventBusService } from 'amdocs-core-package';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private amdocsEventService: AmdocsEventBusService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          const data = body?.data;
          if (!data || typeof data !== 'object') {
            return event;
          }
          const keyName = Object.keys(data)[0];
          if (!keyName) {
            return event;
          }
          const resultset = data[keyName];
          const status = resultset?.statusCode;
          const errorstatus = resultset?.['error']?.message;
          const errorDesc = resultset?.['params']?.ErrorDesc;
          const eligibility = resultset?.['params']?.hasOwnProperty('IsEligible')
            ? (resultset['params'].IsEligible ? 1 : 0)
            : -1;
          if ((data && (status != '200' && errorstatus != null)) || (errorDesc && (eligibility != 0))) {
            this.amdocsEventService.emit('isapiError', true);
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // Auth failures are handled by AuthInterceptor / SSO redirect — avoid noisy popup path
        if (error?.status === 401 || error?.status === 403) {
          console.error('HTTP Auth Error:', error.status, error.message);
          return throwError(() => error);
        }
        console.error('HTTP Error:', error);
        return throwError(() => error);
      })
    );
  }
}
